// import { moduleList } from 'utils/options'

import { moduleList } from 'utils/options'

export function companyName(company) {
    return (
        <div className="flex items-center gap-1">
            <span className="rounded-full w-11 h-11 bg-primary dark:bg-secondary">
                <div className="flex items-center justify-center text-xl font-bold text-white w-11 h-11">
                    {company.image ? (
                        <img className="rounded-full w-11 h-11" src={company.image} alt="logo" />
                    ) : company?.name ? (
                        `${company?.name[0]?.toUpperCase()}${company?.name[1]?.toUpperCase()}`
                    ) : (
                        'QU'
                    )}
                </div>
            </span>
            {company?.name}
        </div>
    )
}

export function serviceName(service) {
    return (
        <div className="flex items-center gap-1">
            <span className="rounded-full w-11 h-11">
                <img className="rounded-full w-11 h-11" src={service?.images[service?.images?.length - 1]?.image} alt="logo" />
            </span>
            {service?.service}
        </div>
    )
}

export function featureName(feature) {
    return (
        <div className="flex items-center gap-1">
            <span className="rounded-full w-11 h-11">
                <img className="rounded-full w-11 h-11" src={feature?.images[feature?.images?.length - 1]?.image} alt="logo" />
            </span>
            {['Machine', 'Grinder'].includes(feature.feature_type)
                ? `${feature?.feature}, Brand-${feature?.brand?.name}, Model-${feature?.machine?.name}`
                : feature?.feature}
        </div>
    )
}

export function activeStatus(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case true:
            className = 'text-success bg-success'
            name = 'Active'
            break
        default:
            className = 'text-danger bg-danger'
            name = 'Inactive'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function mfaStatus(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case true:
            className = 'text-success bg-success'
            name = 'Enabled'
            break
        default:
            className = 'text-danger bg-danger'
            name = 'Disabled'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function fullfillmentStatus(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case true:
            className = 'text-success bg-success'
            name = 'Enable'
            break
        default:
            className = 'text-danger bg-danger'
            name = 'Disabled'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function companyStatus(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case 'active':
            className = 'text-success bg-success'
            name = 'Active'
            break
        default:
            className = 'text-danger bg-danger'
            name = 'Inactive'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function status(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case 'created':
            className = 'text-info bg-info'
            name = 'Created'
            break
        case 'allocated':
            className = 'text-danger bg-danger'
            name = 'Allocated'
            break
        case 'partially allocated':
            className = 'text-danger bg-danger'
            name = 'Partially Allocated'
            break
        case 'picked':
            className = 'text-purple bg-purple'
            name = 'Picked'
            break
        case 'shipped':
            className = 'text-purple bg-purple'
            name = 'Shipped'
            break
        case 'cancelled':
            className = 'text-danger bg-danger'
            name = 'Cancelled'
            break
        case 'partially received':
            className = 'text-meta6 bg-meta6'
            name = 'Partially Received'
            break
        case 'fully received':
            className = 'text-success bg-success'
            name = 'Fully Received'
            break
        default:
            className = 'text-purple bg-purple'
            name = 'Closed'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function siteLabel(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case 'VIC':
            className = 'text-success bg-success'
            name = 'VIC'
            break
        case 'NSW':
            className = 'text-danger bg-danger'
            name = 'NSW'
            break
        case 'SA':
            className = 'text-info bg-info'
            name = 'SA'
            break
        default:
            className = 'text-success bg-success'
            name = 'QLD'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function orderType(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case 'B2B':
            className = 'text-purple bg-purple'
            name = 'B2B'
            break
        case 'B2C':
            className = 'text-purple bg-purple'
            name = 'B2C'
            break
        default:
            className = 'text-purple bg-purple'
            name = 'OTH'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function carrier(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case 'Australia Post':
            className = 'text-purple bg-purple'
            name = 'Australia Post'
            break
        case 'Startrack':
            className = 'text-purple bg-purple'
            name = 'Startrack'
            break
        default:
            className = 'text-meta6 bg-meta6'
            name = 'Border Express'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function asnType(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case '20 Container':
            className = 'text-purple bg-purple'
            name = '20 Container'
            break
        case 'Loose Container Load':
            className = 'text-purple bg-purple'
            name = 'Loose Container Load'
            break
        default:
            className = 'text-purple bg-purple'
            name = '40 Container'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function supplier(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case 'Supplier 1':
            className = 'text-success bg-success'
            name = 'Supplier 1'
            break
        case 'Supplier 2':
            className = 'text-purple bg-purple'
            name = 'Supplier 2'
            break
        default:
            className = 'text-meta6 bg-meta6'
            name = 'Supplier 3'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function carrierService(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case 'Express':
            className = 'text-info bg-info'
            name = 'Express'
            break
        case 'Premium':
            className = 'text-purple bg-purple'
            name = 'Premium'
            break
        default:
            className = 'text-danger bg-danger'
            name = 'Standard'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function numberFormat(
    value,
    currency,
    digits = 2,
    style = 'currency' // decimal, currency, percent, unit
) {
    value = style === 'percent' ? value / 100 : value
    return new Intl.NumberFormat('en-US', {
        style: style,
        currency: currency ?? 'USD',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(value)
}

export function actionType(name) {
    if (name.includes('add')) {
        return 'create'
    } else if (name.includes('change')) {
        return 'edit'
    } else if (name.includes('view')) {
        return 'view'
    } else {
        return 'delete'
    }
}

export function title(name) {
    if (name.includes('add')) {
        return 'Add New'
    } else if (name.includes('change')) {
        return 'Edit'
    } else if (name.includes('view')) {
        return 'List'
    } else {
        return 'Delete'
    }
}

export function moduleName(name) {
    return moduleList.find(item => item.key === name)?.name ?? name
}

export function convertString(string) {
    if (typeof string === 'string') {
        let arr = string
            .toLowerCase()
            .split('-')
            .map(item => item.charAt(0).toUpperCase() + item.substring(1))
        return arr.join(' ')
    }
}

export function convertToCSV(data) {
    if (!data.length) return ''

    const headers = Object.keys(data[0])
    const csvRows = [
        headers.join(','), // header row
        ...data.map(obj => headers.map(header => `"${obj[header]}"`).join(',')),
    ]

    return csvRows.join('\n')
}

export function getPagination(current, total, delta = 2) {
    const range = []
    const rangeWithDots = []
    let last

    for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
            range.push(i)
        }
    }

    for (let i of range) {
        if (last) {
            if (i - last === 2) {
                rangeWithDots.push(last + 1)
            } else if (i - last > 2) {
                rangeWithDots.push('...')
            }
        }
        rangeWithDots.push(i)
        last = i
    }

    return ['Previous', ...rangeWithDots, 'Next']
}
